var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmarkicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.154,8.645l4.667,5.111c0.138,0.151 0.332,0.239 0.537,0.244c0.205,0.004 0.402,-0.075 0.547,-0.22l9.25,-9.25c0.293,-0.292 0.293,-0.768 0,-1.06c-0.292,-0.293 -0.768,-0.293 -1.06,-0l-8.695,8.695c-0,-0 -4.138,-4.532 -4.138,-4.532c-0.279,-0.305 -0.754,-0.327 -1.059,-0.048c-0.306,0.279 -0.328,0.754 -0.049,1.06Z",
    id: "id_101",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375,2l-7,0c-2.071,-0 -3.75,1.679 -3.75,3.75l-0,12.5c0,2.071 1.679,3.75 3.75,3.75l12.5,0c2.071,-0 3.75,-1.679 3.75,-3.75c-0,-2.946 -0,-7 -0,-7c-0,-0.414 -0.336,-0.75 -0.75,-0.75c-0.414,0 -0.75,0.336 -0.75,0.75c-0,0 -0,4.054 0,7c0,1.243 -1.007,2.25 -2.25,2.25c-0,0 -12.5,0 -12.5,0c-1.243,-0 -2.25,-1.007 -2.25,-2.25c-0,-0 0,-12.5 0,-12.5c0,-1.243 1.007,-2.25 2.25,-2.25l7,0c0.414,0 0.75,-0.336 0.75,-0.75c0,-0.414 -0.336,-0.75 -0.75,-0.75Z",
    id: "id_102",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkicon);
export default __webpack_public_path__ + "static/media/checkmarkicon.ad614e02edaede107a261c0d3a263d6b.svg";
export { ForwardRef as ReactComponent };